import { useCallback, useContext } from 'react'
import { ConfigContext } from '../store/ConfigContext'
import { ContentStackTypes } from '../store/Constants'

export const useExternalLink = () => {
  const { cachedCMS } = useContext(ConfigContext)

  const findExternalLink = useCallback(
    (linkTitle) => {
      return cachedCMS
        ?.get(ContentStackTypes.external_links.content_type_uid)
        ?.all_links.find(
          (externalLink) =>
            externalLink?.link?.title?.toUpperCase() ===
            linkTitle?.toUpperCase()
        )
    },
    [cachedCMS]
  )

  const findExternalLinkByLink = (linkHref) => {
    return cachedCMS
      .get(ContentStackTypes.external_links.content_type_uid)
      .all_links.find(
        (externalLink) =>
          externalLink.link.href.toUpperCase() === linkHref.toUpperCase()
      )
  }

  const replaceStringByExternalLink = (content, param, link) => {
    return content.replace(`[[EXTERNAL_LINKS(${param})]]`, link)
  }

  const getExternalLinkParameter = (cmsLink) => {
    if (
      cmsLink.indexOf('[[EXTERNAL_LINKS(') === -1 ||
      cmsLink.indexOf(')]]') === -1
    ) {
      return null
    }
    return cmsLink.split('[[EXTERNAL_LINKS(')[1].split(')]]')[0]
  }

  const replaceContentWithExternalLink = (content) => {
    if (!content.startsWith('[[HAVE_EXTERNAL_LINK]]')) {
      return content
    }
    let parameter = getExternalLinkParameter(content)
    let finalContent = content.replace('[[HAVE_EXTERNAL_LINK]]', '')
    while (parameter) {
      const link = findExternalLink(parameter)
      finalContent = replaceStringByExternalLink(
        finalContent,
        parameter,
        link?.link?.href || '#'
      )
      parameter = getExternalLinkParameter(finalContent)
    }
    return finalContent
  }

  return {
    findExternalLink,
    findExternalLinkByLink,
    replaceContentWithExternalLink
  }
}
